import {MapNode, DisconnectedMapNode} from 'common/src/modules/nodes/nodes.types';
import {sharedCampaigns} from '@cl/shared';

/***
 * Converts a disconnected map node to a connected map node.
 * @param disconnectedNode - The disconnected map node to convert.
 * @returns The connected map node.
 */
export default function toConnectedMapNode(disconnectedNode: DisconnectedMapNode): MapNode {
  const nodes = sharedCampaigns.nodesRef.value;
  const originalNode = nodes[disconnectedNode.id];

  return {
    ...disconnectedNode,
    ...originalNode,
    inputs:
      originalNode?.inputs?.map((input) => ({
        node: input.node,
        outputIdx: input.outputIdx,
      })) ?? [],
    outputs:
      originalNode?.outputs?.map((output) => ({
        ...output,
        node: output.node,
      })) ?? [],
  };
}
